<template>
  <div class="upload">
    <van-form @submit="onSubmit">
      <van-field
        v-model="meilist"
        name="项目名"
        label="项目名"
        placeholder="点击选择项目名"
        readonly
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择项目名' }]"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="lists"
          :default-index="meiIndex"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-field name="uploader" label="图片上传">
        <template #input>
          <van-uploader
            v-model="uploader"
            accept="image/*"
            :after-read="afterRead"
            :max-count="1"
            :max-size="10 * 1024 * 1024"
            @oversize="onOversize"
          />
        </template>
      </van-field>

      <div style="margin: 16px; text-align: center">
        <button type="submit" class="sub-btn">
          <img
            src="https://i.tmuyun.com/webpic/W0202203/W020220328/W020220328554726733019.png"
            alt=""
          />
        </button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Uploader, Toast, Grid, GridItem, Dialog } from "vant";
import { hasUser, addJfwmPic, myJfwmPic } from "@/api/jfwm";

export default {
  name: "upload",
  data() {
    return {
      uploader: [],
      meilist: "",
      doing: false,
      lists: ["爱国爱家美", "孝老爱亲美", "邻里和谐美", "热心奉献美"],
      showPicker: false,
      meiIndex: "",
      existLists: [],
      exist: false,
    };
  },
  created() {
    // 判断是否登记过
    hasUser().then((res) => {
      const data = res.data;
      if (data.has_user !== 1) {
        this.$router.push("/jfwm/sign");
      }
    });
  },
  mounted() {
    this.meiIndex = this.$route.params.mei || "";
    this.meilist = this.meiIndex >= 0 ? this.lists[this.meiIndex] : "";

    myJfwmPic().then((res) => {
      this.existLists = res.data.lists;
      // console.log(this.existLists);
    });
  },
  methods: {
    onConfirm(value, index) {
      this.meilist = value;
      this.meiIndex = index + 1;
      this.showPicker = false;
    },
    onSubmit() {
      if (this.doing) return false;
      this.doing = true;

      // 判断是否已经存在了
      try {
        this.existLists.forEach((v, k) => {
          if (v.meilist == this.meiIndex) {
            this.exist = true;
            throw "break";
          }
        });
      } catch (e) {
        if (e !== "break") throw e;
      }

      let self = this;

      if (this.exist) {
        Dialog.confirm({
          title: "温馨提示",
          message:
            self.meilist +
            "的照片已经存在，确认上传将会覆盖原来的照片。是否确认提交？",
        })
          .then(() => {
            this.doUpload();
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.doUpload();
      }
    },
    doUpload() {
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
      });

      let self = this;
      this.uploader.forEach((v, k) => {
        const file = {
          name: v.file.name,
          size: v.file.size,
          type: v.file.type,
        };
        v.file = file;
      });

      const postData = {
        upload: this.uploader[0],
        meilist: parseInt(this.meiIndex) + 1,
      };
      // console.log(postData);

      addJfwmPic(postData)
        .then((res) => {
          // console.log(res);
          Toast.success({
            message: res.msg,
            onClose() {
              self.$router.push("/jfwm/list");
            },
          });
        })
        .catch((err) => {
          Toast.error(err);
          this.doing = false;
        });
    },
    onOversize(file) {
      // console.log(file);
      Toast("文件大小不能超过10MB");
    },
    afterRead(file) {
      // console.log(file);
    },
  },
};
</script>

<style lang="less" scoped>
.upload {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .sub-btn {
    background-color: transparent;
    border: none;
    width: 50vw;
    img {
      width: 100%;
    }
  }
}
</style>